import { render, staticRenderFns } from "./CookieNote.vue?vue&type=template&id=bdafd2fc&scoped=true&"
import script from "./CookieNote.vue?vue&type=script&lang=js&"
export * from "./CookieNote.vue?vue&type=script&lang=js&"
import style0 from "./CookieNote.vue?vue&type=style&index=0&id=bdafd2fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdafd2fc",
  null
  
)

export default component.exports